import React, { useEffect, useState } from "react";
import HeroSection from "./HeroSection";
import ToolsSection from "./ToolsSection";
import Suggested from "./Suggested";
import AboutUs from "./AboutUs";
import { useNavigate } from "react-router-dom";
import "./HomePage.css";
import { listenAdminMessageCount } from "../adminMessages";

export default function HomePage() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    const uid = localStorage.getItem("uid");
    if (!uid) {
      navigate("/login");
      return;
    }
    setUser(uid);
  }, [navigate]);

  useEffect(() => {
    if (user) {
      listenAdminMessageCount(user, setUnreadCount);
    }
  }, [user]);

  if (!user) return null;

  return (
    <div className="home-container">

      {/* 🔔 FLOATING MESSAGE ICON */}
      {unreadCount > 0 && (
        <div
          className="message-fab"
          onClick={() => navigate("/messages")}
        >
          <span className="message-icon">i</span>
          <span className="message-badge">{unreadCount}</span>
        </div>
      )}

      {/* ✅ IMAGE FIRST SECTION */}
      <HeroSection />

      {/* ✅ IMAGE SECOND SECTION */}
      <ToolsSection />

      {/* ✅ KEEP SAME */}
      <Suggested />
      <AboutUs />

    </div>
  );
}
